import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { RetrieveCourtPaymentsComponent } from './pages/retrieve-court-payments/retrieve-court-payments.component';
import { ConfirmPaymentsDetailsComponent } from './pages/confirm-payments-details/confirm-payments-details.component';
import { CourtPaymentComponent } from './pages/court-payment/court-payment.component';
import { PaymentCancelComponent } from './pages/payment-cancel/payment-cancel.component';
import { PaymentSuccessComponent } from './pages/payment-success/payment-success.component';
import { PaymentAbortedComponent } from './pages/payment-aborted/payment-aborted.component';
import { CourtDepositComponent } from './pages/court-deposit/court-deposit.component';
import {CourtDepositDetailsComponent} from './pages/court-deposit-details/court-deposit-details.component';
import {PrivacyStatementComponent} from './pages/privacy-statement/privacy-statement.component';
import {TermsOfUseComponent} from './pages/terms-of-use/terms-of-use.component';
import {FaqsComponent} from './pages/faqs/faqs.component';

export const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'court-payment-landing', component: RetrieveCourtPaymentsComponent},
    {path: 'court-payment-details', component: ConfirmPaymentsDetailsComponent},
    {path: 'court-payment', component: CourtPaymentComponent},
    {path: 'payment-cancel', component: PaymentCancelComponent},
    {path: 'payment-success', component: PaymentSuccessComponent},
    {path: 'payment-aborted', component: PaymentAbortedComponent},
    {path: 'court-deposit', component: CourtDepositComponent},
    {path: 'court-deposit-details', component: CourtDepositDetailsComponent},
    {path: 'privacy-statement', component: PrivacyStatementComponent},
    {path: 'terms-of-use', component: TermsOfUseComponent},
    {path: 'faqs', component: FaqsComponent}

];
